import React from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap'
import { IoPersonCircle, IoExitOutline } from 'react-icons/io5'
import { useAuth } from '../../contexts/AuthContext';
import logo from "../../logo-transparente.png"

export default function Navigation() {
    const { logout } = useAuth();

    async function handleLogOut() {
        await logout();
    }

    return(
        <>
            <Navbar collapseOnSelect sticky="top" expand="lg" bg="light" variant="light" >
                <Container>
                    <Navbar.Brand style={{fontSize: "1.5rem"}} href="/">
                        <img src={logo} alt="Inventario Provell" style={{ maxHeight: "55px"}}/>
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav className="justify-content-start" style={{ width: "100%", fontSize: "1rem" }}>
                            <Nav.Link href="/products">Inventario</Nav.Link>
                            <Nav.Link href="/resupplies">Entradas</Nav.Link>
                            <Nav.Link href="/sales">Ventas</Nav.Link>
                            <Nav.Link href="/customers">Clientes</Nav.Link>
                            <Nav.Link href="/sellers">Vendedores</Nav.Link>
                        </Nav>
                        <Nav className="justify-content-end" style={{ width: "100%", fontSize: "1.75rem" }}>
                            <Nav.Link href="/profile"><IoPersonCircle/></Nav.Link>
                            <Nav.Link onClick={handleLogOut}><IoExitOutline/></Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </>
    )
}